// extracted by mini-css-extract-plugin
export default {"wrapper":"styles__wrapper___WCzoM","header":"styles__header___Ohgip","createNewButton":"styles__createNewButton___DX7q9"};